import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'a-badge',
    templateUrl: './a-badge.component.html',
    styleUrls: ['./a-badge.component.scss'],
    standalone: false
})
export class ABadgeComponent implements OnInit {

    @Input()
    public size: Size = 'DEFAULT';

    @Input()
    public pulse: boolean;

    @Input()
    public visibility: Visibility = 'HIGH';

    constructor() {
    }

    public fromVisibility = fromVisibility;
    public fromSize = fromSize;

    ngOnInit(): void {
    }
}

export type Size = 'LARGE' | 'DEFAULT' | 'SMALL' | 'TINY';


export function fromSize(size: Size): string {
    switch (size) {
        case 'LARGE':
            return '_large';
        case 'DEFAULT':
            return '_default';
        case 'SMALL':
            return '_small';
        case 'TINY':
            return '_tiny';
    }
}

export type Visibility = 'HIGH' | 'HIGHREVERT' | 'MEDIUM' | 'LOW' | 'LOWREVERT' | 'DISCOVER' | 'DESIGN'
    | 'DEVELOP' | 'DEPLOY' | 'PILOT' | 'SUCCESS'  | 'WARNING' | 'ERROR' | 'ALERT' | 'UNKNOWN' | 'IN_PROGRESS' | 'NOT_STARTED' | 'DONE' | 'DISABLED';

export function fromVisibility(visibility: Visibility): string {
    switch (visibility) {
        case 'HIGHREVERT':
            return '_highRevert';
        case 'HIGH':
            return '_high';
        case 'MEDIUM':
            return '_medium';
        case 'LOWREVERT':
            return '_lowRevert';
        case 'LOW':
            return '_low';
        case 'DISCOVER':
            return '_discover';
        case 'DESIGN':
            return '_design';
        case 'DEVELOP':
            return '_develop';
        case 'DEPLOY':
            return '_deploy';
        case 'PILOT':
            return '_pilot';
        case 'SUCCESS':
            return '_success';
        case 'WARNING':
            return '_warning';
        case 'ERROR':
            return '_error';
        case 'ALERT':
            return '_alert';
        case 'UNKNOWN':
            return '_unknown';
        case 'DONE':
            return '_done';
        case 'NOT_STARTED':
            return '_notStarted';
        case 'IN_PROGRESS':
            return '_inProgress';
        case 'DISABLED':
            return '_disabled';
    }
}
